import axios from "axios";
import { getMsalInstance } from "./msalInstance";
import { getMsalAccount } from "./msalAccount";
import { getBackendScopes } from "./authConfig";
import { isLikelyJwt } from "./tokenShape";

let interceptorId = null;

export const setupMsalAxiosInterceptor = () => {
  if (interceptorId !== null) return;

  interceptorId = axios.interceptors.request.use(
    async (config) => {
      const instance = getMsalInstance();
      const account = getMsalAccount();

      if (!instance || !account) return config;

      try {
        const response = await instance.acquireTokenSilent({
          scopes: getBackendScopes(),
          account,
        });
        const accessToken = response?.accessToken;
        if (isLikelyJwt(accessToken)) {
          config.headers = config.headers || {};
          config.headers.Authorization = `Bearer ${accessToken}`;
        } else {
          if (config.headers) delete config.headers.Authorization;
        }
      } catch {
        // Silent acquisition failed (e.g. needs interaction, misconfigured scopes).
        // Strip any stale auth header so the backend returns a clean 401,
        // which the existing AuthenticationFailureHandler converts into a re-auth redirect.
        if (config.headers) {
          delete config.headers.Authorization;
        }
      }

      return config;
    },
    (error) => Promise.reject(error)
  );
};
